import React from "react";
import FadedRightImage from "../common/FadedRightImage";
import AboutUsSvg from "../../Icons/AboutUsSvg";

export default function TopFadedAboutUsImage() {
  return (
    <FadedRightImage
      title="We are here for you!"
      description="Only One step away from achieving your dreams!!! "
      image= {<AboutUsSvg/>}
    />
  );
}
